import React from 'react'
import { deleteUser } from 'aws-amplify/auth'
import useSWRMutation from 'swr/mutation'

import { softDeleteUser } from '../../../api/users'
import Loading from '../../components/layout/Loading'
import Button from '../../components/form/Button'
import { useI18N } from '../../../libraries/i18n/hook'

type Props = { handleCancel: () => void }
const DeleteAccount:React.FC<Props> = ({ handleCancel }) => {
  const { t } = useI18N()
  const { trigger: submitDelete, isMutating } = useSWRMutation('/users/delete', softDeleteUser)

  const handleDelete = async () => {
    // Call Auth.delete from cognito
    await submitDelete()
    await deleteUser()
    window.alert(t('auth.account.delete.success'))
  }
  if(isMutating) {
    return <Loading />
  }
  return (
    <div className='max-w-[680px] flex flex-wrap gap-y-3 gap-x-4 justify-center items-center bg-soft-green p-2 sm:p-4 rounded-md'>
      {t('auth.account.delete.confirm')}
      <Button size='sm' onClick={handleCancel}>{t('auth.account.delete.confirm.no')}</Button>
      <Button size='sm' outlined onClick={handleDelete}>{t('auth.account.delete.confirm.yes')}</Button>
    </div>
  )
}

export default DeleteAccount
